import { closeDrawer, openDrawer } from "@actions/drawer-actions";
import { useDispatch, useSelector } from "react-redux";

export function useDrawerName() {
  const isDrawerOpen = useSelector((state) => state.drawer.open);
  const user = useSelector((state) => state.user?.currentUser);
  const subscription = user?.subscription;
  const restartAtDate = subscription?.restart_at;
  const currentCloset = useSelector((state) => state.customizableCloset?.currentCloset);

  if (!isDrawerOpen) return null;

  if (!user) return "visitor";

  if (user?.state === "lead") return "user_lead";
  if (user?.state === "subscriber") return `closet_${currentCloset?.state}`;
 
  if (restartAtDate) return "subscription_paused";

  return "subscription_canceled";
}

export function useOpenDrawer() {
  const dispatch = useDispatch();

  return () => dispatch(openDrawer());
}

export function useCloseDrawer() {
  const dispatch = useDispatch();

  return () => dispatch(closeDrawer());
}
